import type { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * `Validators.required` that does not accept whitespace.
 *
 * The stock validator passes on a value of `'   '`, so a form submits, the
 * server trims it to empty and rejects it, and the user gets a round trip
 * instead of a field error. Reports `required`, so existing error markup and
 * `hasError('required')` checks keep working unchanged.
 */
export function requiredTrim(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const raw: unknown = control.value;
    if (raw === null || raw === undefined) return { required: true };
    if (typeof raw === 'string') return raw.trim().length > 0 ? null : { required: true };
    if (Array.isArray(raw)) return raw.length > 0 ? null : { required: true };
    return raw === '' ? { required: true } : null;
  };
}
